import { useEffect, useState } from 'react';
import { useCurrentModule } from '../components';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useEclipsePlanRecommendation } from './useEclipsePlanRecommendation';
import { useRecommendationRevealEnabled } from './useRecommendationRevealEnabled';
import { upgradeStateOf, useUpgradeRecommendation } from './useUpgradeRecommendation';
import { useUpgradeRecommendedProduct } from './useUpgradeRecommendedProduct';
const DECIDING_MS = 1200;
const DESKTOP_BEAT = {
  analyzingMinMs: 1500,
  analyzingMinWithoutGeneratedMs: 2500,
  analyzingMaxMs: 12000
};
const MOBILE_BEAT = {
  analyzingMinMs: 1000,
  analyzingMinWithoutGeneratedMs: 1000,
  analyzingMaxMs: 4000
};
export const useAiRevealController = () => {
  const module = useCurrentModule();
  const beat = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME ? MOBILE_BEAT : DESKTOP_BEAT;
  const {
    showsGeneratedContent
  } = useAiRecommendationEnabled();
  const {
    isEnabled,
    isUpgradeReveal
  } = useRecommendationRevealEnabled();
  const {
    isBulletsLoading
  } = useEclipsePlanRecommendation();
  const {
    isLoading: isUpgradeLoading,
    isError: isUpgradeError,
    data: upgradeData
  } = useUpgradeRecommendation();
  const {
    productId: upgradePickId
  } = useUpgradeRecommendedProduct();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const plansRendered = module.SDK.aiRecommendationStore.useArePlansRendered();
  const recommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const [floorReached, setFloorReached] = useState(false);
  const analyzingMinMs = showsGeneratedContent ? beat.analyzingMinMs : beat.analyzingMinWithoutGeneratedMs;
  const analyzingMaxMs = beat.analyzingMaxMs;
  const isWaitingForRecommendation = isUpgradeReveal ? isUpgradeLoading : showsGeneratedContent ? isBulletsLoading : !recommendedProductId;
  const skipsAnalyzing = isUpgradeReveal && !isUpgradeLoading && (isUpgradeError || upgradeStateOf(upgradeData) === 'stay');
  useEffect(() => {
    if (skipsAnalyzing && !isRevealed) {
      module.SDK.aiRecommendationStore.reveal();
    }
  }, [skipsAnalyzing, isRevealed, module]);
  useEffect(() => {
    if (isUpgradeReveal && upgradePickId) {
      module.SDK.aiRecommendationStore.setRecommendedProductId(upgradePickId);
    }
  }, [isUpgradeReveal, upgradePickId, module]);
  useEffect(() => {
    if (!isEnabled || skipsAnalyzing || isDeciding || isRevealed || !plansRendered) {
      return undefined;
    }
    const floor = setTimeout(() => setFloorReached(true), analyzingMinMs);
    const ceiling = setTimeout(() => module.SDK.aiRecommendationStore.decide(), analyzingMaxMs);
    return () => {
      clearTimeout(floor);
      clearTimeout(ceiling);
    };
  }, [isEnabled, skipsAnalyzing, isDeciding, isRevealed, plansRendered, analyzingMinMs, analyzingMaxMs, module]);
  useEffect(() => {
    if (isEnabled && !skipsAnalyzing && plansRendered && floorReached && !isWaitingForRecommendation && !isDeciding && !isRevealed) {
      module.SDK.aiRecommendationStore.decide();
    }
  }, [isEnabled, skipsAnalyzing, plansRendered, floorReached, isWaitingForRecommendation, isDeciding, isRevealed, module]);
  useEffect(() => {
    if (!isDeciding || isRevealed) {
      return undefined;
    }
    const timer = setTimeout(() => module.SDK.aiRecommendationStore.reveal(), DECIDING_MS);
    return () => clearTimeout(timer);
  }, [isDeciding, isRevealed, module]);
};
//# sourceMappingURL=useAiRevealController.js.map